import React from 'react';
import { Route, Routes } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import adminRoutes from './admin';
import availabilityRoutes from './availability';
import bibsRoutes from './bibs';
import browseRoutes from './browse';
import searchRoutes from './search';
import usersRoutes from './users';
import holdsRoutes from './borrowing/holds';
import infoRoutes from './info';
import listRoutes from './list';
import checkedoutRoutes from './borrowing/checkedout';
import accountMessagesRoutes from './borrowing/accountMessages';
import interlibraryLoansRoutes from './borrowing/interlibraryLoans';
import recentlyReturnedRoutes from './borrowing/recentlyReturned';
import finesRoutes, { finesSubroutes } from './borrowing/fines';
import commentsRoutes from './ugc/comments';
import quotationsRoutes from './ugc/quotations';
import summariesRoutes from './ugc/summaries';
import videosRoutes from './ugc/videos';
import eventsRoutes from './events/search';
import eventsDetailsRoutes from './events';
import locationsRoutes from './locations';
import myEventsRoutes from './events/account';
import eventsPdfRoutes from './events/pdf';
import printRoutes from './print';
import settingsRoutes from './settings';
import widgetsRoutes from './widgets';

export default (
  <Routes>
    {adminRoutes}
    {printRoutes}
    {availabilityRoutes}
    {accountMessagesRoutes}
    {bibsRoutes}
    {checkedoutRoutes}
    {commentsRoutes}
    {myEventsRoutes}
    {eventsPdfRoutes}
    {eventsDetailsRoutes}
    {eventsRoutes}
    {locationsRoutes}
    {finesSubroutes}
    {finesRoutes}
    {holdsRoutes}
    {listRoutes}
    {infoRoutes}
    {interlibraryLoansRoutes}
    {quotationsRoutes}
    {recentlyReturnedRoutes}
    {searchRoutes}
    {settingsRoutes}
    {summariesRoutes}
    {usersRoutes}
    {videosRoutes}
    {widgetsRoutes}
    {browseRoutes}
    <Route
      path="*"
      element={
        <MainLayout>
          <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />
        </MainLayout>
      }
    />
  </Routes>
);
